import { Theme } from '@mui/material';

const useStyles = (theme: Theme) => ({
  modalContent: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // @zawarski/palmetto-direflow-react-table injects a global
    // `.MuiPaper-root { border-radius: 0 !important }` reset that squares every Paper.
    // Re-round the modal card with a higher-specificity + !important rule so it wins,
    // and clip the absolutely-positioned header/footer bars to the rounded shape.
    '&.MuiPaper-root': {
      borderRadius: `${theme.spacing(2)} !important`,
    },
    overflow: 'hidden',
    padding: theme.spacing(2),
    minWidth: '320px',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
      minWidth: '90%',
    },
  },
});

export default useStyles;
